module.exports = __webpack_public_path__ + "static/img/9.bf6b8f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/9.png
// module id = cDh5
// module chunks = 0